import React from 'react';
import PropTypes from 'prop-types';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ModalContainer, CloseButtonContainer, ModalContent, ModalContentLeft } from './Modal.styles';

const ModalComponent = ({
  open,
  onClose,
  children,
  width = 450,
  maxHeight = '50vh',
  alignContent = 'center', // 'center' or 'left'
  showCloseButton = true,
  ariaLabelledBy = 'modal-title',
  variant = 'default', // 'default- dark' or 'secondary'
}) => {
  const ContentComponent = alignContent === 'left' ? ModalContentLeft : ModalContent;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby={ariaLabelledBy}
      slotProps={{
        backdrop: {
          style: {
            backdropFilter: 'blur(6px)',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          }
        }
      }}
    >
      <ModalContainer width={width} maxHeight={maxHeight} variant={variant}>
        {showCloseButton && (
          <CloseButtonContainer>
            <IconButton onClick={onClose} size="small" aria-label="close">
              <CloseIcon />
            </IconButton>
          </CloseButtonContainer>
        )}
        <ContentComponent>{children}</ContentComponent>
      </ModalContainer>
    </Modal>
  );
};

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxHeight: PropTypes.string,
  alignContent: PropTypes.oneOf(['center', 'left']),
  showCloseButton: PropTypes.bool,
  ariaLabelledBy: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'secondary']),
};

export default ModalComponent;
